module.exports = __webpack_public_path__ + "static/media/ALTHAR_WEB_iRWE.ca33c274.png";